import React from 'react';
import { ShowSection } from 'framework/ui/layout';
import { FormShowTemplate } from 'framework/form';
import ChangeRequestsList from './List/ChangeRequestsList';
import useChangeRequestService from './changeRequestService';
import { useProjectDataContext } from 'domain/shared/newProject';
import { EditableListFormShowTemplate } from 'framework/list';

const ChangeRequestContext = () => {
  const { changeRequestsSearch } = useChangeRequestService();
  const { data } = useProjectDataContext();

  return (
    <ShowSection sx={{ '&.section-details__wrapper': { p: '0px !important' } }}>
      <FormShowTemplate
        isInitialsLoadingPosition
        submitFormFunc={values => Promise.resolve()}
        afterSubmit={{
          message: 'You are awesome! Change request has been successfully updated.',
        }}
        getDataFunc={() => changeRequestsSearch(data.id!, { sort: { createdAt: 'DESC' }, pageSize: 100 })}
      >
        <EditableListFormShowTemplate listSource="result">
          <ChangeRequestsList />
        </EditableListFormShowTemplate>
      </FormShowTemplate>
    </ShowSection>
  );
};

export default ChangeRequestContext;
